function init() {
  var ws = {}
  var sdkversion_placeholder = '1.0.0';
  var sdk_type = 'H5'
  var dev_url_arr = ['/ws_api/batchUpload']
  var batch_send_default = {
    datasend_timeout: 10000,
    send_interval: 15000,
    send_max_length: 100
  };
  var wsPara = {};

  var defaultPara = {
    name: 'ws',
    preset_properties: {
      app_platform: '3',
    },
    encrypt_cookie: false,
    max_referrer_string_length: 200,
    max_string_length: 500,
    cross_subdomain: false,
    show_log: false,
    is_encrypt: 1, // 是否加密：1、0
    is_gzip: 0, // 是否压缩：1、0
    debug_mode: false,
    debug_mode_url: '',
    batch_send: true,
    callback_timeout: 200,
    datasend_timeout: 8000,
    noCache: false
  };

  ws.para_default = defaultPara;

  function safeJsonString(obj) {
    try {
      return JSON.stringify(obj, null, '  ');
    } catch (e) {
      return JSON.stringify(obj);
    }
  }

  function sdLog() {
    if (wsPara.show_log) {
      if (typeof console === 'object' && console.log) {
        try {
          return console.log.apply(console, arguments);
        } catch (e) {
          console.log(arguments[0]);
        }
      }
    }
  }

  function getURLSearchParams(queryString) {
    queryString = queryString || '';
    var decodeParam = function (str) {
      return decodeURIComponent(str);
    };
    var args = {};
    var query = queryString.substring(1);
    var pairs = query.split('&');
    for (var i = 0; i < pairs.length; i++) {
      var pos = pairs[i].indexOf('=');
      if (pos === -1) continue;
      var name = pairs[i].substring(0, pos);
      var value = pairs[i].substring(pos + 1);
      name = decodeParam(name);
      value = decodeParam(value);
      args[name] = value;
    }
    return args;
  }

  function getQueryObject(url) {
    url = url == null ? window.location.href : url
    const search = url.substring(url.lastIndexOf('?') + 1)
    const obj = {}
    const reg = /([^?&=]+)=([^?&=]*)/g
    search.replace(reg, (rs, $1, $2) => {
      const name = decodeURIComponent($1)
      let val = decodeURIComponent($2)
      val = String(val)
      obj[name] = val
      return rs
    })
    return obj
  }

  function _URL(url) {
    var result = {};
    var isURLAPIWorking = function () {
      var url_test;
      try {
        url_test = new URL('http://wsecar.com/');
        return url_test.href === 'http://wsecar.com/';
      } catch (e) {
        return false;
      }
    };
    if (typeof window.URL === 'function' && isURLAPIWorking()) {
      result = new URL(url);
      if (!result.searchParams) {
        result.searchParams = (function () {
          var params = getURLSearchParams(result.search);
          return {
            get: function (searchParam) {
              return params[searchParam];
            }
          };
        })();
      }
      return result;
    } else {
      sdLog('暂不支持URL相关功能')
      return {}
    }
  }

  function getRandom(num) {
    var result = ''
    num = num * 1
    let curDateTime = new Date().getTime()
    if (num <= 13) {
      result = curDateTime.substr(0, num)
    } else {
      let randomNum = num - 13
      result = `${curDateTime}${String(Math.random()).substr(2, randomNum)}`
    }
    return result
  }

  var UUID = function() {
    function S4() {
      return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
    }
    return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4())
  }

  function getCookieTopLevelDomain(hostname) {
    hostname = hostname || location.hostname;

    function validHostname(value) {
      if (value) {
        return value;
      } else {
        return false;
      }
    }
    var new_hostname = validHostname(hostname);
    if (!new_hostname) {
      return '';
    }
    var splitResult = new_hostname.split('.');
    if (isArray(splitResult) && splitResult.length >= 2 && !/^(\d+\.)+\d+$/.test(new_hostname)) {
      var domainStr = '.' + splitResult.splice(splitResult.length - 1, 1);
      while (splitResult.length > 0) {
        domainStr = '.' + splitResult.splice(splitResult.length - 1, 1) + domainStr;
        document.cookie = 'wsdata_domain_test=true; path=/; domain=' + domainStr;

        if (document.cookie.indexOf('wsdata_domain_test=true') !== -1) {
          var now = new Date();
          now.setTime(now.getTime() - 1000);

          document.cookie = 'wsdata_domain_test=true; expires=' + now.toGMTString() + '; path=/; domain=' + domainStr;

          return domainStr;
        }
      }
    }
    return '';
  }

  function getCurrentDomain(url) {
    var sdDomain = wsPara.current_domain;
    switch (typeof sdDomain) {
      case 'function':
        var resultDomain = sdDomain();
        if (resultDomain === '' || trim(resultDomain) === '') {
          return 'url解析失败';
        } else if (resultDomain.indexOf('.') !== -1) {
          return resultDomain;
        } else {
          return 'url解析失败';
        }
        case 'string':
          if (wsDomain === '' || trim(wsDomain) === '') {
            return 'url解析失败';
          } else if (wsDomain.indexOf('.') !== -1) {
            return sdDomain;
          } else {
            return 'url解析失败';
          }
          default:
            var cookieTopLevelDomain = getCookieTopLevelDomain();
            if (url === '') {
              return 'url解析失败';
            } else if (cookieTopLevelDomain === '') {
              return 'url解析失败';
            } else {
              return cookieTopLevelDomain;
            }
    }
  }
  

  function _decodeURIComponent(val) {
    var result = val;
    try {
      result = decodeURIComponent(val);
    } catch (e) {
      result = val;
    }
    return result;
  }

  function _decodeURI(val) {
    var result = val;
    try {
      result = decodeURI(val);
    } catch (e) {
      result = val;
    }
    return result;
  }

  function safeJSONParse(str) {
    var val = null;
    try {
      val = JSON.parse(str);
    } catch (e) {
      return false;
    }
    return val;
  }

  function rot13obfs(str, key) {
    str = String(str);
    key = typeof key === 'number' ? key : 13;
    var n = 126;
    var chars = str.split('');
    for (var i = 0, len = chars.length; i < len; i++) {
      var c = chars[i].charCodeAt(0);
      if (c < n) {
        chars[i] = String.fromCharCode((chars[i].charCodeAt(0) + key) % n);
      }
    }
    return chars.join('');
  }

  function rot13defs(str) {
    var key = 13,
      n = 126;
    str = String(str);
    return rot13obfs(str, n - key);
  }

  function getURL(para) {
    if (isString(para)) {
      return _decodeURI(para);
    } else {
      let url = _decodeURI(location.href);
      let url_path = url.includes('?') ? url.substring(0, url.lastIndexOf('?')) : url
      return url_path;
    }
  }

  function unique(ar) {
    var n = [];
    for (var i = 0; i < ar.length; i++) {
      if (n.indexOf(ar[i]) == -1) {
        n.push(ar[i]);
      }
    }
    return n;
  }

  /**
   * aes 128加密
   */
   var CryptoJS = CryptoJS || function (u, p) {
    var d = {}, l = d.lib = {}, s = function () { }, t = l.Base = { extend: function (a) { s.prototype = this; var c = new s; a && c.mixIn(a); c.hasOwnProperty("init") || (c.init = function () { c.$super.init.apply(this, arguments) }); c.init.prototype = c; c.$super = this; return c }, create: function () { var a = this.extend(); a.init.apply(a, arguments); return a }, init: function () { }, mixIn: function (a) { for (var c in a) a.hasOwnProperty(c) && (this[c] = a[c]); a.hasOwnProperty("toString") && (this.toString = a.toString) }, clone: function () { return this.init.prototype.extend(this) } },
    r = l.WordArray = t.extend({
      init: function (a, c) { a = this.words = a || []; this.sigBytes = c != p ? c : 4 * a.length }, toString: function (a) { return (a || v).stringify(this) }, concat: function (a) { var c = this.words, e = a.words, j = this.sigBytes; a = a.sigBytes; this.clamp(); if (j % 4) for (var k = 0; k < a; k++)c[j + k >>> 2] |= (e[k >>> 2] >>> 24 - 8 * (k % 4) & 255) << 24 - 8 * ((j + k) % 4); else if (65535 < e.length) for (k = 0; k < a; k += 4)c[j + k >>> 2] = e[k >>> 2]; else c.push.apply(c, e); this.sigBytes += a; return this }, clamp: function () {
        var a = this.words, c = this.sigBytes; a[c >>> 2] &= 4294967295 <<
          32 - 8 * (c % 4); a.length = u.ceil(c / 4)
      }, clone: function () { var a = t.clone.call(this); a.words = this.words.slice(0); return a }, random: function (a) { for (var c = [], e = 0; e < a; e += 4)c.push(4294967296 * u.random() | 0); return new r.init(c, a) }
    }), w = d.enc = {}, v = w.Hex = {
      stringify: function (a) { var c = a.words; a = a.sigBytes; for (var e = [], j = 0; j < a; j++) { var k = c[j >>> 2] >>> 24 - 8 * (j % 4) & 255; e.push((k >>> 4).toString(16)); e.push((k & 15).toString(16)) } return e.join("") }, parse: function (a) {
        for (var c = a.length, e = [], j = 0; j < c; j += 2)e[j >>> 3] |= parseInt(a.substr(j,
          2), 16) << 24 - 4 * (j % 8); return new r.init(e, c / 2)
      }
    }, b = w.Latin1 = { stringify: function (a) { var c = a.words; a = a.sigBytes; for (var e = [], j = 0; j < a; j++)e.push(String.fromCharCode(c[j >>> 2] >>> 24 - 8 * (j % 4) & 255)); return e.join("") }, parse: function (a) { for (var c = a.length, e = [], j = 0; j < c; j++)e[j >>> 2] |= (a.charCodeAt(j) & 255) << 24 - 8 * (j % 4); return new r.init(e, c) } }, x = w.Utf8 = { stringify: function (a) { try { return decodeURIComponent(escape(b.stringify(a))) } catch (c) { throw Error("Malformed UTF-8 data"); } }, parse: function (a) { return b.parse(unescape(encodeURIComponent(a))) } },
    q = l.BufferedBlockAlgorithm = t.extend({
      reset: function () { this._data = new r.init; this._nDataBytes = 0 }, _append: function (a) { "string" == typeof a && (a = x.parse(a)); this._data.concat(a); this._nDataBytes += a.sigBytes }, _process: function (a) { var c = this._data, e = c.words, j = c.sigBytes, k = this.blockSize, b = j / (4 * k), b = a ? u.ceil(b) : u.max((b | 0) - this._minBufferSize, 0); a = b * k; j = u.min(4 * a, j); if (a) { for (var q = 0; q < a; q += k)this._doProcessBlock(e, q); q = e.splice(0, a); c.sigBytes -= j } return new r.init(q, j) }, clone: function () {
        var a = t.clone.call(this);
        a._data = this._data.clone(); return a
      }, _minBufferSize: 0
    }); l.Hasher = q.extend({
      cfg: t.extend(), init: function (a) { this.cfg = this.cfg.extend(a); this.reset() }, reset: function () { q.reset.call(this); this._doReset() }, update: function (a) { this._append(a); this._process(); return this }, finalize: function (a) { a && this._append(a); return this._doFinalize() }, blockSize: 16, _createHelper: function (a) { return function (b, e) { return (new a.init(e)).finalize(b) } }, _createHmacHelper: function (a) {
        return function (b, e) {
          return (new n.HMAC.init(a,
            e)).finalize(b)
        }
      }
    }); var n = d.algo = {}; return d
  }(Math);
  (function () {
    var u = CryptoJS, p = u.lib.WordArray; u.enc.Base64 = {
      stringify: function (d) { var l = d.words, p = d.sigBytes, t = this._map; d.clamp(); d = []; for (var r = 0; r < p; r += 3)for (var w = (l[r >>> 2] >>> 24 - 8 * (r % 4) & 255) << 16 | (l[r + 1 >>> 2] >>> 24 - 8 * ((r + 1) % 4) & 255) << 8 | l[r + 2 >>> 2] >>> 24 - 8 * ((r + 2) % 4) & 255, v = 0; 4 > v && r + 0.75 * v < p; v++)d.push(t.charAt(w >>> 6 * (3 - v) & 63)); if (l = t.charAt(64)) for (; d.length % 4;)d.push(l); return d.join("") }, parse: function (d) {
        var l = d.length, s = this._map, t = s.charAt(64); t && (t = d.indexOf(t), -1 != t && (l = t)); for (var t = [], r = 0, w = 0; w <
          l; w++)if (w % 4) { var v = s.indexOf(d.charAt(w - 1)) << 2 * (w % 4), b = s.indexOf(d.charAt(w)) >>> 6 - 2 * (w % 4); t[r >>> 2] |= (v | b) << 24 - 8 * (r % 4); r++ } return p.create(t, r)
      }, _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
    }
  })();
  (function (u) {
    function p(b, n, a, c, e, j, k) { b = b + (n & a | ~n & c) + e + k; return (b << j | b >>> 32 - j) + n } function d(b, n, a, c, e, j, k) { b = b + (n & c | a & ~c) + e + k; return (b << j | b >>> 32 - j) + n } function l(b, n, a, c, e, j, k) { b = b + (n ^ a ^ c) + e + k; return (b << j | b >>> 32 - j) + n } function s(b, n, a, c, e, j, k) { b = b + (a ^ (n | ~c)) + e + k; return (b << j | b >>> 32 - j) + n } for (var t = CryptoJS, r = t.lib, w = r.WordArray, v = r.Hasher, r = t.algo, b = [], x = 0; 64 > x; x++)b[x] = 4294967296 * u.abs(u.sin(x + 1)) | 0; r = r.MD5 = v.extend({
      _doReset: function () { this._hash = new w.init([1732584193, 4023233417, 2562383102, 271733878]) },
      _doProcessBlock: function (q, n) {
        for (var a = 0; 16 > a; a++) { var c = n + a, e = q[c]; q[c] = (e << 8 | e >>> 24) & 16711935 | (e << 24 | e >>> 8) & 4278255360 } var a = this._hash.words, c = q[n + 0], e = q[n + 1], j = q[n + 2], k = q[n + 3], z = q[n + 4], r = q[n + 5], t = q[n + 6], w = q[n + 7], v = q[n + 8], A = q[n + 9], B = q[n + 10], C = q[n + 11], u = q[n + 12], D = q[n + 13], E = q[n + 14], x = q[n + 15], f = a[0], m = a[1], g = a[2], h = a[3], f = p(f, m, g, h, c, 7, b[0]), h = p(h, f, m, g, e, 12, b[1]), g = p(g, h, f, m, j, 17, b[2]), m = p(m, g, h, f, k, 22, b[3]), f = p(f, m, g, h, z, 7, b[4]), h = p(h, f, m, g, r, 12, b[5]), g = p(g, h, f, m, t, 17, b[6]), m = p(m, g, h, f, w, 22, b[7]),
          f = p(f, m, g, h, v, 7, b[8]), h = p(h, f, m, g, A, 12, b[9]), g = p(g, h, f, m, B, 17, b[10]), m = p(m, g, h, f, C, 22, b[11]), f = p(f, m, g, h, u, 7, b[12]), h = p(h, f, m, g, D, 12, b[13]), g = p(g, h, f, m, E, 17, b[14]), m = p(m, g, h, f, x, 22, b[15]), f = d(f, m, g, h, e, 5, b[16]), h = d(h, f, m, g, t, 9, b[17]), g = d(g, h, f, m, C, 14, b[18]), m = d(m, g, h, f, c, 20, b[19]), f = d(f, m, g, h, r, 5, b[20]), h = d(h, f, m, g, B, 9, b[21]), g = d(g, h, f, m, x, 14, b[22]), m = d(m, g, h, f, z, 20, b[23]), f = d(f, m, g, h, A, 5, b[24]), h = d(h, f, m, g, E, 9, b[25]), g = d(g, h, f, m, k, 14, b[26]), m = d(m, g, h, f, v, 20, b[27]), f = d(f, m, g, h, D, 5, b[28]), h = d(h, f,
            m, g, j, 9, b[29]), g = d(g, h, f, m, w, 14, b[30]), m = d(m, g, h, f, u, 20, b[31]), f = l(f, m, g, h, r, 4, b[32]), h = l(h, f, m, g, v, 11, b[33]), g = l(g, h, f, m, C, 16, b[34]), m = l(m, g, h, f, E, 23, b[35]), f = l(f, m, g, h, e, 4, b[36]), h = l(h, f, m, g, z, 11, b[37]), g = l(g, h, f, m, w, 16, b[38]), m = l(m, g, h, f, B, 23, b[39]), f = l(f, m, g, h, D, 4, b[40]), h = l(h, f, m, g, c, 11, b[41]), g = l(g, h, f, m, k, 16, b[42]), m = l(m, g, h, f, t, 23, b[43]), f = l(f, m, g, h, A, 4, b[44]), h = l(h, f, m, g, u, 11, b[45]), g = l(g, h, f, m, x, 16, b[46]), m = l(m, g, h, f, j, 23, b[47]), f = s(f, m, g, h, c, 6, b[48]), h = s(h, f, m, g, w, 10, b[49]), g = s(g, h, f, m,
              E, 15, b[50]), m = s(m, g, h, f, r, 21, b[51]), f = s(f, m, g, h, u, 6, b[52]), h = s(h, f, m, g, k, 10, b[53]), g = s(g, h, f, m, B, 15, b[54]), m = s(m, g, h, f, e, 21, b[55]), f = s(f, m, g, h, v, 6, b[56]), h = s(h, f, m, g, x, 10, b[57]), g = s(g, h, f, m, t, 15, b[58]), m = s(m, g, h, f, D, 21, b[59]), f = s(f, m, g, h, z, 6, b[60]), h = s(h, f, m, g, C, 10, b[61]), g = s(g, h, f, m, j, 15, b[62]), m = s(m, g, h, f, A, 21, b[63]); a[0] = a[0] + f | 0; a[1] = a[1] + m | 0; a[2] = a[2] + g | 0; a[3] = a[3] + h | 0
      }, _doFinalize: function () {
        var b = this._data, n = b.words, a = 8 * this._nDataBytes, c = 8 * b.sigBytes; n[c >>> 5] |= 128 << 24 - c % 32; var e = u.floor(a /
          4294967296); n[(c + 64 >>> 9 << 4) + 15] = (e << 8 | e >>> 24) & 16711935 | (e << 24 | e >>> 8) & 4278255360; n[(c + 64 >>> 9 << 4) + 14] = (a << 8 | a >>> 24) & 16711935 | (a << 24 | a >>> 8) & 4278255360; b.sigBytes = 4 * (n.length + 1); this._process(); b = this._hash; n = b.words; for (a = 0; 4 > a; a++)c = n[a], n[a] = (c << 8 | c >>> 24) & 16711935 | (c << 24 | c >>> 8) & 4278255360; return b
      }, clone: function () { var b = v.clone.call(this); b._hash = this._hash.clone(); return b }
    }); t.MD5 = v._createHelper(r); t.HmacMD5 = v._createHmacHelper(r)
  })(Math);
  (function () {
    var u = CryptoJS, p = u.lib, d = p.Base, l = p.WordArray, p = u.algo, s = p.EvpKDF = d.extend({ cfg: d.extend({ keySize: 4, hasher: p.MD5, iterations: 1 }), init: function (d) { this.cfg = this.cfg.extend(d) }, compute: function (d, r) { for (var p = this.cfg, s = p.hasher.create(), b = l.create(), u = b.words, q = p.keySize, p = p.iterations; u.length < q;) { n && s.update(n); var n = s.update(d).finalize(r); s.reset(); for (var a = 1; a < p; a++)n = s.finalize(n), s.reset(); b.concat(n) } b.sigBytes = 4 * q; return b } }); u.EvpKDF = function (d, l, p) {
      return s.create(p).compute(d,
        l)
    }
  })();
  CryptoJS.lib.Cipher || function (u) {
    var p = CryptoJS, d = p.lib, l = d.Base, s = d.WordArray, t = d.BufferedBlockAlgorithm, r = p.enc.Base64, w = p.algo.EvpKDF, v = d.Cipher = t.extend({
      cfg: l.extend(), createEncryptor: function (e, a) { return this.create(this._ENC_XFORM_MODE, e, a) }, createDecryptor: function (e, a) { return this.create(this._DEC_XFORM_MODE, e, a) }, init: function (e, a, b) { this.cfg = this.cfg.extend(b); this._xformMode = e; this._key = a; this.reset() }, reset: function () { t.reset.call(this); this._doReset() }, process: function (e) { this._append(e); return this._process() },
      finalize: function (e) { e && this._append(e); return this._doFinalize() }, keySize: 4, ivSize: 4, _ENC_XFORM_MODE: 1, _DEC_XFORM_MODE: 2, _createHelper: function (e) { return { encrypt: function (b, k, d) { return ("string" == typeof k ? c : a).encrypt(e, b, k, d) }, decrypt: function (b, k, d) { return ("string" == typeof k ? c : a).decrypt(e, b, k, d) } } }
    }); d.StreamCipher = v.extend({ _doFinalize: function () { return this._process(!0) }, blockSize: 1 }); var b = p.mode = {}, x = function (e, a, b) {
      var c = this._iv; c ? this._iv = u : c = this._prevBlock; for (var d = 0; d < b; d++)e[a + d] ^=
        c[d]
    }, q = (d.BlockCipherMode = l.extend({ createEncryptor: function (e, a) { return this.Encryptor.create(e, a) }, createDecryptor: function (e, a) { return this.Decryptor.create(e, a) }, init: function (e, a) { this._cipher = e; this._iv = a } })).extend(); q.Encryptor = q.extend({ processBlock: function (e, a) { var b = this._cipher, c = b.blockSize; x.call(this, e, a, c); b.encryptBlock(e, a); this._prevBlock = e.slice(a, a + c) } }); q.Decryptor = q.extend({
      processBlock: function (e, a) {
        var b = this._cipher, c = b.blockSize, d = e.slice(a, a + c); b.decryptBlock(e, a); x.call(this,
          e, a, c); this._prevBlock = d
      }
    }); b = b.CBC = q; q = (p.pad = {}).Pkcs7 = { pad: function (a, b) { for (var c = 4 * b, c = c - a.sigBytes % c, d = c << 24 | c << 16 | c << 8 | c, l = [], n = 0; n < c; n += 4)l.push(d); c = s.create(l, c); a.concat(c) }, unpad: function (a) { a.sigBytes -= a.words[a.sigBytes - 1 >>> 2] & 255 } }; d.BlockCipher = v.extend({
      cfg: v.cfg.extend({ mode: b, padding: q }), reset: function () {
        v.reset.call(this); var a = this.cfg, b = a.iv, a = a.mode; if (this._xformMode == this._ENC_XFORM_MODE) var c = a.createEncryptor; else c = a.createDecryptor, this._minBufferSize = 1; this._mode = c.call(a,
          this, b && b.words)
      }, _doProcessBlock: function (a, b) { this._mode.processBlock(a, b) }, _doFinalize: function () { var a = this.cfg.padding; if (this._xformMode == this._ENC_XFORM_MODE) { a.pad(this._data, this.blockSize); var b = this._process(!0) } else b = this._process(!0), a.unpad(b); return b }, blockSize: 4
    }); var n = d.CipherParams = l.extend({ init: function (a) { this.mixIn(a) }, toString: function (a) { return (a || this.formatter).stringify(this) } }), b = (p.format = {}).OpenSSL = {
      stringify: function (a) {
        var b = a.ciphertext; a = a.salt; return (a ? s.create([1398893684,
          1701076831]).concat(a).concat(b) : b).toString(r)
      }, parse: function (a) { a = r.parse(a); var b = a.words; if (1398893684 == b[0] && 1701076831 == b[1]) { var c = s.create(b.slice(2, 4)); b.splice(0, 4); a.sigBytes -= 16 } return n.create({ ciphertext: a, salt: c }) }
    }, a = d.SerializableCipher = l.extend({
      cfg: l.extend({ format: b }), encrypt: function (a, b, c, d) { d = this.cfg.extend(d); var l = a.createEncryptor(c, d); b = l.finalize(b); l = l.cfg; return n.create({ ciphertext: b, key: c, iv: l.iv, algorithm: a, mode: l.mode, padding: l.padding, blockSize: a.blockSize, formatter: d.format }) },
      decrypt: function (a, b, c, d) { d = this.cfg.extend(d); b = this._parse(b, d.format); return a.createDecryptor(c, d).finalize(b.ciphertext) }, _parse: function (a, b) { return "string" == typeof a ? b.parse(a, this) : a }
    }), p = (p.kdf = {}).OpenSSL = { execute: function (a, b, c, d) { d || (d = s.random(8)); a = w.create({ keySize: b + c }).compute(a, d); c = s.create(a.words.slice(b), 4 * c); a.sigBytes = 4 * b; return n.create({ key: a, iv: c, salt: d }) } }, c = d.PasswordBasedCipher = a.extend({
      cfg: a.cfg.extend({ kdf: p }), encrypt: function (b, c, d, l) {
        l = this.cfg.extend(l); d = l.kdf.execute(d,
          b.keySize, b.ivSize); l.iv = d.iv; b = a.encrypt.call(this, b, c, d.key, l); b.mixIn(d); return b
      }, decrypt: function (b, c, d, l) { l = this.cfg.extend(l); c = this._parse(c, l.format); d = l.kdf.execute(d, b.keySize, b.ivSize, c.salt); l.iv = d.iv; return a.decrypt.call(this, b, c, d.key, l) }
    })
  }();
  (function () {
    for (var u = CryptoJS, p = u.lib.BlockCipher, d = u.algo, l = [], s = [], t = [], r = [], w = [], v = [], b = [], x = [], q = [], n = [], a = [], c = 0; 256 > c; c++)a[c] = 128 > c ? c << 1 : c << 1 ^ 283; for (var e = 0, j = 0, c = 0; 256 > c; c++) { var k = j ^ j << 1 ^ j << 2 ^ j << 3 ^ j << 4, k = k >>> 8 ^ k & 255 ^ 99; l[e] = k; s[k] = e; var z = a[e], F = a[z], G = a[F], y = 257 * a[k] ^ 16843008 * k; t[e] = y << 24 | y >>> 8; r[e] = y << 16 | y >>> 16; w[e] = y << 8 | y >>> 24; v[e] = y; y = 16843009 * G ^ 65537 * F ^ 257 * z ^ 16843008 * e; b[k] = y << 24 | y >>> 8; x[k] = y << 16 | y >>> 16; q[k] = y << 8 | y >>> 24; n[k] = y; e ? (e = z ^ a[a[a[G ^ z]]], j ^= a[a[j]]) : e = j = 1 } var H = [0, 1, 2, 4, 8,
      16, 32, 64, 128, 27, 54], d = d.AES = p.extend({
        _doReset: function () {
          for (var a = this._key, c = a.words, d = a.sigBytes / 4, a = 4 * ((this._nRounds = d + 6) + 1), e = this._keySchedule = [], j = 0; j < a; j++)if (j < d) e[j] = c[j]; else { var k = e[j - 1]; j % d ? 6 < d && 4 == j % d && (k = l[k >>> 24] << 24 | l[k >>> 16 & 255] << 16 | l[k >>> 8 & 255] << 8 | l[k & 255]) : (k = k << 8 | k >>> 24, k = l[k >>> 24] << 24 | l[k >>> 16 & 255] << 16 | l[k >>> 8 & 255] << 8 | l[k & 255], k ^= H[j / d | 0] << 24); e[j] = e[j - d] ^ k } c = this._invKeySchedule = []; for (d = 0; d < a; d++)j = a - d, k = d % 4 ? e[j] : e[j - 4], c[d] = 4 > d || 4 >= j ? k : b[l[k >>> 24]] ^ x[l[k >>> 16 & 255]] ^ q[l[k >>>
            8 & 255]] ^ n[l[k & 255]]
        }, encryptBlock: function (a, b) { this._doCryptBlock(a, b, this._keySchedule, t, r, w, v, l) }, decryptBlock: function (a, c) { var d = a[c + 1]; a[c + 1] = a[c + 3]; a[c + 3] = d; this._doCryptBlock(a, c, this._invKeySchedule, b, x, q, n, s); d = a[c + 1]; a[c + 1] = a[c + 3]; a[c + 3] = d }, _doCryptBlock: function (a, b, c, d, e, j, l, f) {
          for (var m = this._nRounds, g = a[b] ^ c[0], h = a[b + 1] ^ c[1], k = a[b + 2] ^ c[2], n = a[b + 3] ^ c[3], p = 4, r = 1; r < m; r++)var q = d[g >>> 24] ^ e[h >>> 16 & 255] ^ j[k >>> 8 & 255] ^ l[n & 255] ^ c[p++], s = d[h >>> 24] ^ e[k >>> 16 & 255] ^ j[n >>> 8 & 255] ^ l[g & 255] ^ c[p++], t =
            d[k >>> 24] ^ e[n >>> 16 & 255] ^ j[g >>> 8 & 255] ^ l[h & 255] ^ c[p++], n = d[n >>> 24] ^ e[g >>> 16 & 255] ^ j[h >>> 8 & 255] ^ l[k & 255] ^ c[p++], g = q, h = s, k = t; q = (f[g >>> 24] << 24 | f[h >>> 16 & 255] << 16 | f[k >>> 8 & 255] << 8 | f[n & 255]) ^ c[p++]; s = (f[h >>> 24] << 24 | f[k >>> 16 & 255] << 16 | f[n >>> 8 & 255] << 8 | f[g & 255]) ^ c[p++]; t = (f[k >>> 24] << 24 | f[n >>> 16 & 255] << 16 | f[g >>> 8 & 255] << 8 | f[h & 255]) ^ c[p++]; n = (f[n >>> 24] << 24 | f[g >>> 16 & 255] << 16 | f[h >>> 8 & 255] << 8 | f[k & 255]) ^ c[p++]; a[b] = q; a[b + 1] = s; a[b + 2] = t; a[b + 3] = n
        }, keySize: 8
      }); u.AES = p._createHelper(d)
  })();

  var CryptoJSF = {
    getKeyOrIv: function(val) {
      return CryptoJS.enc.Utf8.parse(val);
    },
    AesEncrypt: function(word, key, iv) {
      let encrypted = CryptoJS.AES.encrypt(word, this.getKeyOrIv(key), {
        iv: this.getKeyOrIv(iv),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    Base64Encode: function(val) {
      let str = CryptoJS.enc.Utf8.parse(val);
      let base64 = CryptoJS.enc.Base64.stringify(str);
      return base64;
    }
  }

  function BatchSend() {
    this.sendingData = 0;
    this.sendingItemKeys = [];
  }

  BatchSend.prototype = {
    add: function (data) {
      if (isObject(data)) {
        this.writeStore(data);
        let storeData = this.readStore();
        let eventType = ['PageView']
        if (eventType.includes(data.preset_properties.events_id) || storeData.keys.length >= ws.para.batch_send.send_max_length) {
          this.sendStrategy(storeData);
        }
      }
    },
    clearPendingStatus: function () {
      if (this.sendingItemKeys.length) {
        this.removePendingItems(this.sendingItemKeys);
      }
    },
    remove: function (keys) {
      if (this.sendingData > 0) {
        --this.sendingData;
      }
      if (isArray(keys) && keys.length > 0) {
        each(keys, function (key) {
          _localstorage.remove(key);
        });
      }
    },
    send: function (data) {
      var me = this;
      var server_url;
      if ((isString(ws.para.server_url) && ws.para.server_url !== '') || (isArray(ws.para.server_url) && ws.para.server_url.length)) {
        server_url = isArray(ws.para.server_url) ? ws.para.server_url[0] : ws.para.server_url;
      } else {
        ws.log('当前 server_url 为空或不正确，只在控制台打印日志，network 中不会发数据，请配置正确的 server_url！');
        return;
      }
      let key = getRandom(16)
      let iv = getRandom(16)
      if (ws.store.changeUUID) {
        data.vals.forEach(obj => {
          obj.preset_properties.user_id = ws.store._state.user_id
          obj.preset_properties.uuid = ws.store._state.uuid
        })
      }
      sdLog('发送数据；', data)
      let dataStr = null
      var trace_id = UUID()
      if (ws.para.is_encrypt) {
        dataStr = `${key}${iv}${CryptoJSF.AesEncrypt(JSON.stringify(data.vals), key, iv)}`
      } else {
        dataStr = `${CryptoJSF.Base64Encode(JSON.stringify(data.vals))}`
      }
      var sendData = {
        trace_id,
        send_time: new Date().getTime(),
        sdk_version: sdkversion_placeholder,
        sdk_type: sdk_type,
        ip: null,
        encrypt: ws.para.is_encrypt,
        gzip: ws.para.is_gzip,
        data: dataStr
      }
      ajax({
        url: server_url,
        type: 'POST',
        data: JSON.stringify(sendData),
        timeout: ws.para.batch_send.datasend_timeout,
        cors: true,
        header: {
          'trace-id': trace_id
        },
        contentType: 'application/json',
        success: function () {
          ws.store.changeUUID = false
          me.remove(data.keys);
          me.removePendingItems(data.keys);
        },
        error: function () {
          sdLog('send error')
          if (me.sendingData > 0) {
            --me.sendingData;
          }
          me.removePendingItems(data.keys);
        }
      });
    },
    appendPendingItems: function (newKeys) {
      if (isArray(newKeys) === false) {
        return;
      }
      this.sendingItemKeys = unique(this.sendingItemKeys.concat(newKeys));
      try {
        var existingItems = this.getPendingItems();
        var newItems = unique(existingItems.concat(newKeys));
        localStorage.setItem('wswebjssdk-sendingitems', JSON.stringify(newItems));
      } catch (e) {}
    },
    removePendingItems: function (keys) {
      if (isArray(keys) === false) {
        return;
      }
      if (this.sendingItemKeys.length) {
        this.sendingItemKeys = filter(this.sendingItemKeys, function (item) {
          return indexOf(keys, item) === -1;
        });
      }
      try {
        var existingItems = this.getPendingItems();
        var newItems = filter(existingItems, function (item) {
          return indexOf(keys, item) === -1;
        });
        localStorage.setItem('wswebjssdk-sendingitems', JSON.stringify(newItems));
      } catch (e) {}
    },
    getPendingItems: function () {
      var items = [];
      try {
        var value = localStorage.getItem('wswebjssdk-sendingitems');
        if (value) {
          items = JSON.parse(value);
        }
      } catch (e) {}
      return items;
    },
    removePageItems: function() {
      let pageEvents = ['PageView', 'PageEnd']
      var existingItems = this.getPendingItems();
      var newItems = filter(existingItems, function (item) {
        let storageObj = JSON.parse(_localstorage.get(item))
        return !pageEvents.includes(storageObj.preset_properties.events_id)
      });
      localStorage.setItem('wswebjssdk-sendingitems', JSON.stringify(newItems));
    },
    sendPrepare: function (data) {
      this.appendPendingItems(data.keys);
      var arr = data.vals;
      var arrLen = arr.length;
      if (arrLen > 0) {
        this.send({
          keys: data.keys,
          vals: arr
        });
      }
    },
    sendStrategy: function (storeData=null) {
      var data = storeData || this.readStore();
      if (data.keys.length > 0 && this.sendingData === 0) {
        this.sendingData = 1;
        this.sendPrepare(data);
      }
    },
    batchInterval: function () {
      var me = this;
      setInterval(function () {
        me.sendStrategy();
      }, ws.para.batch_send.send_interval);
    },
    readStore: function () {
      var keys = [];
      var vals = [];
      var val = null;
      var now = new Date().getTime();
      var len = localStorage.length;
      var pendingItems = this.getPendingItems();
      for (var i = 0; i < len; i++) {
        var itemName = localStorage.key(i);
        if (itemName.indexOf('wswebjssdk-') === 0 && /^wswebjssdk\-\d+$/.test(itemName)) {
          if (pendingItems.length && indexOf(pendingItems, itemName) > -1) {
            continue;
          }
          val = localStorage.getItem(itemName);
          if (val) {
            val = safeJSONParse(val);
            if (val && isObject(val)) {
              keys.push(itemName);
              vals.push(val);
            } else {
              localStorage.removeItem(itemName);
              ws.log('localStorage-数据parse异常' + val);
            }
          } else {
            localStorage.removeItem(itemName);
            ws.log('localStorage-数据取值异常' + val);
          }
        }
      }
      return {
        keys: keys,
        vals: vals
      };
    },
    writeStore: function (data) {
      var uuid = String(new Date().getTime()) + String(parseInt(Math.random()*1000));
      localStorage.setItem('wswebjssdk-' + uuid, JSON.stringify(data));
    }
  };

  var debug = {
    protocolIsSame: function (url1, url2) {
      try {
        if (dev_url_arr.includes(url1) || url2.indexOf('localhost') > -1) {
          return true
        }
        if (_URL(url1).protocol !== _URL(url2).protocol) {
          return false;
        }
      } catch (error) {
        sdLog('不支持 _.URL 方法');
        return false;
      }
      return true;
    },
    serverUrl: function () {
      if (isString(wsPara.server_url) && wsPara.server_url !== '' && !this.protocolIsSame(wsPara.server_url, location.href)) {
        sdLog('SDK 检测到您的数据发送地址和当前页面地址的协议不一致，建议您修改成一致的协议。\n因为：1、https 下面发送 http 的图片请求会失败。2、http 页面使用 https + ajax 方式发数据，在 ie9 及以下会丢失数据。');
      }
    },
    ajax: function (url) {
      if (url === wsPara.server_url) {
        return false;
      }
      if (isString(url) && url !== '' && !this.protocolIsSame(url, location.href)) {
        sdLog('SDK 检测到您的数据发送地址和当前页面地址的协议不一致，建议您修改成一致的协议。因为 http 页面使用 https + ajax 方式发数据，在 ie9 及以下会丢失数据。');
      }
    }
  };

  var pageInfo = {
    initPage: function () {
      var referrer = getReferrer();
      var url = getURL();

      this.pageProp = {
        referrer: referrer,
        url: url
      };
    },
    pageProp: {},
    currentProps: {},
    register: function (obj) {
      extend(pageInfo.currentProps, obj);
    }
  };

  var cookie = {
    get: function (name) {
      var nameEQ = name + '=';
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) == 0) {
          return _decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
      }
      return null;
    },
    set: function (name, value, days, cross_subdomain) {
      cross_subdomain = typeof cross_subdomain === 'undefined' ? wsPara.cross_subdomain : cross_subdomain;
      var cdomain = '',
        expires = '',
        secure = '',
        samesite = '';
      days = days == null ? 73000 : days;

      if (cross_subdomain) {
        var domain = getCurrentDomain(location.href);
        if (domain === 'url解析失败') {
          domain = '';
        }
        cdomain = domain ? '; domain=' + domain : '';
      }

      if (days !== 0) {
        var date = new Date();
        if (String(days).slice(-1) === 's') {
          date.setTime(date.getTime() + Number(String(days).slice(0, -1)) * 1000);
        } else {
          date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        }

        expires = '; expires=' + date.toGMTString();
      }
      if (isString(wsPara.set_cookie_samesite) && wsPara.set_cookie_samesite !== '') {
        samesite = '; SameSite=' + wsPara.set_cookie_samesite;
      }
      if (wsPara.is_secure_cookie) {
        secure = '; secure';
      }

      function getValid(data) {
        if (data) {
          return data.replace(/\r\n/g, '');
        } else {
          return false;
        }
      }
      var valid_name = '';
      var valid_value = '';
      var valid_domain = '';
      if (name) {
        valid_name = getValid(name);
      }
      if (value) {
        valid_value = getValid(value);
      }
      if (cdomain) {
        valid_domain = getValid(cdomain);
      }
      if (valid_name && valid_value) {
        document.cookie = valid_name + '=' + encodeURIComponent(valid_value) + expires + '; path=/' + valid_domain + samesite + secure;
      }
    },
    encrypt: function (v) {
      return 'data:enc;' + rot13obfs(v);
    },
    decrypt: function (v) {
      v = v.substring('data:enc;'.length);
      v = rot13defs(v);
      return v;
    },
    resolveValue: function (cross) {
      var flag = 'data:enc;';
      if (isString(cross) && cross.indexOf(flag) === 0) {
        cross = cookie.decrypt(cross);
      }
      return cross;
    },

    remove: function (name, cross_subdomain) {
      cross_subdomain = typeof cross_subdomain === 'undefined' ? wsPara.cross_subdomain : cross_subdomain;
      cookie.set(name, '', -1, cross_subdomain);
    }
  };

  var _localstorage = {
    get: function (name) {
      return window.localStorage.getItem(name);
    },

    parse: function (name) {
      var storedValue;
      try {
        storedValue = JSON.parse(_localstorage.get(name)) || null;
      } catch (err) {
        sdLog(err);
      }
      return storedValue;
    },

    set: function (name, value) {
      window.localStorage.setItem(name, value);
    },

    remove: function (name) {
      window.localStorage.removeItem(name);
    },

    isSupport: function () {
      var supported = true;
      try {
        var supportName = '__wsdatasupport__';
        var val = 'testIsSupportLocalstorage';
        _localstorage.set(supportName, val);
        if (_localstorage.get(supportName) !== val) {
          supported = false;
        }
        _localstorage.remove(supportName);
      } catch (err) {
        supported = false;
      }
      return supported;
    }
  };

  var ArrayProto = Array.prototype;
  var nativeForEach = ArrayProto.forEach;
  var slice = ArrayProto.slice;
  var nativeIsArray = Array.isArray;
  var ObjProto = Object.prototype;
  var toString = ObjProto.toString;
  var hasOwnProperty = ObjProto.hasOwnProperty;
  var breaker = {};

  var isArray =
    nativeIsArray ||
    function (obj) {
      return toString.call(obj) === '[object Array]';
    };

  function each(obj, iterator, context) {
    if (obj == null) {
      return false;
    }
    if (nativeForEach && obj.forEach === nativeForEach) {
      obj.forEach(iterator, context);
    } else if (isArray(obj) && obj.length === +obj.length) {
      for (var i = 0, l = obj.length; i < l; i++) {
        if (i in obj && iterator.call(context, obj[i], i, obj) === breaker) {
          return false;
        }
      }
    } else {
      for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) {
          if (iterator.call(context, obj[key], key, obj) === breaker) {
            return false;
          }
        }
      }
    }
  }

  function extend(obj) {
    each(slice.call(arguments, 1), function (source) {
      for (var prop in source) {
        if (hasOwnProperty.call(source, prop) && source[prop] !== void 0) {
          obj[prop] = source[prop];
        }
      }
    });
    return obj;
  }

  function extend2Lev(obj) {
    each(slice.call(arguments, 1), function (source) {
      for (var prop in source) {
        if (source[prop] !== void 0) {
          if (isObject(source[prop]) && isObject(obj[prop])) {
            extend(obj[prop], source[prop]);
          } else {
            obj[prop] = source[prop];
          }
        }
      }
    });
    return obj;
  }

  function isSupportCors() {
    if (typeof window.XMLHttpRequest === 'undefined') {
      return false;
    }
    if ('withCredentials' in new XMLHttpRequest()) {
      return true;
    } else if (typeof XDomainRequest !== 'undefined') {
      return true;
    } else {
      return false;
    }
  }

  function isFunction(f) {
    if (!f) {
      return false;
    }
    var type = toString.call(f);
    return type == '[object Function]' || type == '[object AsyncFunction]';
  }

  function isArguments(obj) {
    return !!(obj && hasOwnProperty.call(obj, 'callee'));
  }

  function toArray(iterable) {
    if (!iterable) {
      return [];
    }
    if (iterable.toArray) {
      return iterable.toArray();
    }
    if (isArray(iterable)) {
      return slice.call(iterable);
    }
    if (isArguments(iterable)) {
      return slice.call(iterable);
    }
    return values(iterable);
  }

  function values(obj) {
    var results = [];
    if (obj == null) {
      return results;
    }
    each(obj, function (value) {
      results[results.length] = value;
    });
    return results;
  }

  function indexOf(arr, target) {
    var indexof = arr.indexOf;
    if (indexof) {
      return indexof.call(arr, target);
    } else {
      for (var i = 0; i < arr.length; i++) {
        if (target === arr[i]) {
          return i;
        }
      }
      return -1;
    }
  }

  function filter(arr, fn, self) {
    var hasOwn = Object.prototype.hasOwnProperty;
    if (arr.filter) {
      return arr.filter(fn);
    }
    var ret = [];
    for (var i = 0; i < arr.length; i++) {
      if (!hasOwn.call(arr, i)) {
        continue;
      }
      var val = arr[i];
      if (fn.call(self, val, i, arr)) {
        ret.push(val);
      }
    }
    return ret;
  }

  function trim(str) {
    return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
  }

  function isObject(obj) {
    if (obj == null) {
      return false;
    } else {
      return toString.call(obj) == '[object Object]';
    }
  }

  function isEmptyObject(obj) {
    if (isObject(obj)) {
      for (var key in obj) {
        if (hasOwnProperty.call(obj, key)) {
          return false;
        }
      }
      return true;
    }
    return false;
  }

  function isUndefined(obj) {
    return obj === void 0;
  }

  function isString(obj) {
    return toString.call(obj) == '[object String]';
  }

  function isDate(obj) {
    return toString.call(obj) == '[object Date]';
  }

  function isBoolean(obj) {
    return toString.call(obj) == '[object Boolean]';
  }

  function isNumber(obj) {
    return toString.call(obj) == '[object Number]' && /[\d\.]+/.test(String(obj));
  }

  function isElement(obj) {
    return !!(obj && obj.nodeType === 1);
  }

  function isJSONString(str) {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  function getReferrer(referrer) {
    referrer = referrer || document.referrer;
    if (typeof referrer !== 'string') {
      return '取值异常_referrer异常_' + String(referrer);
    }
    referrer = decodeURI(referrer);
    if (referrer.indexOf('https://www.baidu.com/') === 0) {
      referrer = referrer.split('?')[0];
    }
    referrer = referrer.slice(0, ws.para.max_referrer_string_length);
    return typeof referrer === 'string' ? referrer : '';
  }

  function addEvent() {
    function fixEvent(event) {
      if (event) {
        event.preventDefault = fixEvent.preventDefault;
        event.stopPropagation = fixEvent.stopPropagation;
        event._getPath = fixEvent._getPath;
      }
      return event;
    }
    fixEvent._getPath = function () {
      var ev = this;
      return this.path || (this.composedPath && this.composedPath()) || ry(ev.target).getParents();
    };

    fixEvent.preventDefault = function () {
      this.returnValue = false;
    };
    fixEvent.stopPropagation = function () {
      this.cancelBubble = true;
    };

    var register_event = function (element, type, handler) {
      var useCapture = false;
      if (type === 'click') {
        useCapture = true;
      }
      if (element && element.addEventListener) {
        element.addEventListener(
          type,
          function (e) {
            e._getPath = fixEvent._getPath;
            handler.call(this, e);
          },
          useCapture
        );
      } else {
        var ontype = 'on' + type;
        var old_handler = element[ontype];
        element[ontype] = makeHandler(element, handler, old_handler, type);
      }
    };

    function makeHandler(element, new_handler, old_handlers, type) {
      var handler = function (event) {
        event = event || fixEvent(window.event);
        if (!event) {
          return undefined;
        }
        event.target = event.srcElement;

        var ret = true;
        var old_result, new_result;
        if (typeof old_handlers === 'function') {
          old_result = old_handlers(event);
        }
        new_result = new_handler.call(element, event);
        if (type !== 'beforeunload') {
          if (false === old_result || false === new_result) {
            ret = false;
          }
          return ret;
        }
      };
      return handler;
    }

    register_event.apply(null, arguments);
  }

  function xhr(cors) {
    if (cors) {
      if (typeof window.XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest()) {
        return new XMLHttpRequest();
      } else {
        return null;
      }
    } else {
      if (typeof window.XMLHttpRequest !== 'undefined') {
        return new XMLHttpRequest();
      }
      if (window.ActiveXObject) {
        try {
          return new ActiveXObject('Msxml2.XMLHTTP');
        } catch (d) {
          try {
            return new ActiveXObject('Microsoft.XMLHTTP');
          } catch (d) {
            sdLog(d);
          }
        }
      }
    }
  }

  function ajax(para) {
    para.timeout = para.timeout || 20000;

    para.credentials = typeof para.credentials === 'undefined' ? true : para.credentials;

    function getJSON(data) {
      if (!data) {
        return '';
      }
      try {
        return JSON.parse(data);
      } catch (e) {
        return {};
      }
    }

    var g = xhr(para.cors);

    if (!g) {
      return false;
    }

    if (!para.type) {
      para.type = para.data ? 'POST' : 'GET';
    }
    para = extend({
        success: function () {},
        error: function () {}
      },
      para
    );

    debug.ajax(para.url);

    var oldsuccess = para.success;
    var olderror = para.error;
    var errorTimer;

    function abort() {
      try {
        if (isObject(g) && g.abort) {
          g.abort();
        }
      } catch (error) {
        sdLog(error);
      }

      if (errorTimer) {
        clearTimeout(errorTimer);
        errorTimer = null;
        para.error && para.error();
        g.onreadystatechange = null;
      }
    }

    para.success = function (data) {
      oldsuccess(data);
      if (errorTimer) {
        clearTimeout(errorTimer);
        errorTimer = null;
      }
    };
    para.error = function (err) {
      olderror(err);
      if (errorTimer) {
        clearTimeout(errorTimer);
        errorTimer = null;
      }
    };

    errorTimer = setTimeout(function () {
      abort();
    }, para.timeout);

    g.onreadystatechange = function () {
      try {
        if (g.readyState == 4) {
          if ((g.status >= 200 && g.status < 300) || g.status == 304) {
            para.success(getJSON(g.responseText));
          } else {
            para.error(getJSON(g.responseText), g.status);
          }
          g.onreadystatechange = null;
        }
      } catch (e) {
        g.onreadystatechange = null;
      }
    };
    g.open(para.type, para.url, true);
    try {
      if (para.credentials) {
        g.withCredentials = true;
      }
      if (isObject(para.header)) {
        each(para.header, function (v, i) {
          g.setRequestHeader && g.setRequestHeader(i, v);
        });
      }

      if (para.data) {
        if (!para.cors) {
          g.setRequestHeader && g.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        }
        if (para.contentType === 'application/json') {
          g.setRequestHeader && g.setRequestHeader('Content-type', 'application/json; charset=UTF-8');
        } else {
          g.setRequestHeader && g.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        }
      }
    } catch (e) {
      sdLog(e);
    }

    g.send(para.data || null);
  }

  /**
   * 获取设备型号、操作系统、操作系统版本、浏览器名、浏览器版本
   * */
  function getBrowserInfo() {
    const navigator = window.navigator;
    const userAgent = navigator.userAgent.toLowerCase(); // 访问者的信息。
    let model = ''; // 应用系统名称
    let os = getModelEquipment(); // 设备型号
    let os_version = ''; // 操作系统版本
    let browser = getBrowser(); // 浏览器名称, 浏览器版本
    // 如果是安卓的话, 获取具体的厂家品牌
    if (os == "android") {
      model = getAndriodModel();
      os_version = getAndroidVersion()
    } else if (os == "iphone" || os == 'ipad') {
      model = os
      os_version = getIosVersion()
    }
    // 获取IOS设备版本
    function getIosVersion() {
      let ver = userAgent.match(/os (.*?) like mac os/);
      let version = ver ? ver[1].replace(/_/g, '.') : 'other'
      return version
    }
    // 获取安卓设备版本
    function getAndroidVersion() {
      let ver = userAgent.match(/android (.*?);/);
      let version = ver ? ver[1] : 'other'
      return version
    }
    // 获取安卓设备型号
    function getAndriodModel() {
      let ver = ''
      if (userAgent.indexOf('build') >= 0) {
        ver = userAgent.match(/android [\d|\.]+; (.*) build/);
      } else {
        ver = userAgent.match(/android [\d|\.]+; (\w*) .*\)/);
      }
      let model = ver ? ver[1] : 'other'
      return model;
    }
    // 获取浏览器名称和浏览器版本
    function getBrowser() {
      var browserMap = {
        appname: "unknown",
        version: 0,
      };
      if (/(msie|firefox|opera|chrome|netscape)\D+(\d[\d.]*)/.test(userAgent)) {
        browserMap.appname = RegExp.$1;
        browserMap.version = RegExp.$2;
      } else if (/safari\/(\d+.?\d?)/.test(userAgent)) {
        browserMap.appname = "safari";
        browserMap.version = RegExp.$1;
      }
      return {
        browser_name: browserMap.appname, // 浏览器名称
        browser_version: browserMap.version, // 浏览器版本
      };
    }
    // 获取设备型号
    function getModelEquipment() {
      let modelEquipment = "";
      let Agents = [
        "android",
        "iphone",
        "symbianos",
        "ipad",
        "ipod",
        "windows",
      ];
      for (let v = 0; v < Agents.length; v++) {
        if (userAgent.includes(Agents[v])) {
          modelEquipment = Agents[v];
          break;
        }
      }
      return modelEquipment;
    }
    return {
      model,
      os,
      os_version,
      browser: browser.browser_name,
      browser_version: browser.browser_version
    }
  }

  var store = {
    changeUUID: false,
    _state: {
      uuid: '',
      user_id: '',
      props: {}
    },
    getProps: function () {
      return this._state.props || {};
    },
    getUserId: function () {
      return this._state.user_id;
    },
    getUUID: function () {
      return this._state.uuid;
    },
    getUnionId: function () {
      var obj = {};
      var uuid = this._state.uuid;
      if (uuid) {
        obj.login_id = uuid;
      }
      return obj;
    },
    toState: function (ds) {
      var state = null;
      if (ds != null && isJSONString(ds)) {
        state = JSON.parse(ds);
        this._state = extend(state);
        if (state.uuid) {
          if (typeof state.props === 'object') {
            for (var key in state.props) {
              if (typeof state.props[key] === 'string') {
                state.props[key] = state.props[key].slice(0, ws.para.max_referrer_string_length);
              }
            }
            this.save();
          }
        } else {
          this.set('uuid', UUID());
        }
      } else {
        this.set('uuid', UUID());
      }
    },

    setOnce: function (a, b) {
      if (!(a in this._state)) {
        this.set(a, b);
      }
    },
    set: function (name, value) {
      this._state = this._state || {};
      var pre_id = this._state.uuid;
      this._state[name] = value;
      this.save();
      if (name === 'uuid' && pre_id) {
        this.changeUUID = true
      }
    },
    setProps: function (newp, isCover) {
      var props = {};
      if (!isCover) {
        props = extend(this._state.props || {}, newp);
      } else {
        props = newp;
      }
      for (var key in props) {
        if (typeof props[key] === 'string') {
          props[key] = props[key].slice(0, ws.para.max_referrer_string_length);
        }
      }
      this.set('props', props);
    },
    setPropsOnce: function (newp) {
      var props = this._state.props || {};
      coverExtend(props, newp);
      this.set('props', props);
    },
    clearAllProps: function (arr) {
      var i;
      if (isArray(arr) && arr.length > 0) {
        for (i = 0; i < arr.length; i++) {
          if (isString(arr[i]) && arr[i].indexOf('latest_') === -1 && isObject(this._state.props) && arr[i] in this._state.props) {
            delete this._state.props[arr[i]];
          }
        }
      } else {
        if (isObject(this._state.props)) {
          for (i in this._state.props) {
            if (i.indexOf('latest_') !== 1) {
              delete this._state.props[i];
            }
          }
        }
      }
      this.save();
    },
    save: function () {
      var copyState = {
        uuid: this._state.uuid,
        user_id: this._state.user_id
      };

      var stateStr = JSON.stringify(copyState);
      if (ws.para.encrypt_cookie) {
        stateStr = cookie.encrypt(stateStr);
      }
      cookie.set(this.getCookieName(), stateStr, 73000, ws.para.cross_subdomain);
    },
    getCookieName: function () {
      var sub = '';
      if (ws.para.cross_subdomain === false) {
        try {
          sub = _URL(location.href).hostname;
        } catch (e) {
          ws.log(e);
        }
        if (typeof sub === 'string' && sub !== '') {
          sub = 'ws_jssdk_' + sub.replace(/\./g, '_');
        } else {
          sub = 'ws_jssdk_root';
        }
      } else {
        sub = 'wsdatajssdk';
      }
      return sub;
    },
    init: function () {
      var uuid = UUID();
      var cross = cookie.get(this.getCookieName());
      cross = cookie.resolveValue(cross);
      if (cross === null) {
        this.set('uuid', uuid);
      } else {
        this.toState(cross);
      }
      var browserInfo = this.getBrowserParam()
      this.setProps(browserInfo)
    },
    getBrowserParam: function () {
      try {
        if (navigator.userAgent) {
          return getBrowserInfo()
        }
      } catch (e) {
        ws.log('获取浏览器信息异常')
      }
    }
  };

  ws.register = function (props) {
    if (saEvent.check({
        properties: props
      })) {
      store.setProps(props);
    } else {
      ws.log('register输入的参数有误');
    }
  };

  ws.registerOnce = function (props) {
    if (saEvent.check({
        properties: props
      })) {
      store.setPropsOnce(props);
    } else {
      ws.log('registerOnce输入的参数有误');
    }
  };

  ws.login = function (id, callback) {
    if (typeof id === 'number') {
      id = String(id);
    }
    if (saEvent.check({
        userId: id
      })) {
      var userId = store.getUserId();
      if (id !== userId) {
        if (!userId) {
          store.set('user_id', id);
        }
      } else {
        callback && callback();
      }
    } else {
      ws.log('login的参数必须是字符串');
      callback && callback();
    }
  };

  ws.logout = function (isChangeId) {
    var userId = store.getUserId();
    if (userId) {
      store.set('user_id', '');
      if (isChangeId) {
        var uuid = UUID();
        store.set('uuid', uuid);
      }
    } else {
      ws.log('没有user_id，logout失败');
    }
  };

  ws.readyState = {
    state: 0,
    historyState: [],
    stateType: {
      1: '1-init未开始',
      2: '2-init开始',
      3: '3-store完成'
    },
    getState: function () {
      return this.historyState.join('\n');
    },
    setState: function (n) {
      if (String(n) in this.stateType) {
        this.state = n;
      }
      this.historyState.push(this.stateType[n]);
    }
  };

  ws.initialState = {
    queue: [],
    isComplete: false,
    nativeIsComplete: false, // 与APP、小程序数据交互完成
    storeIsComplete: false, // 配置参数初始化完成
    checkIsComplete: function () {
      if (this.nativeIsComplete && this.storeIsComplete) {
        this.isComplete = true
        if (this.queue.length > 0) {
          each(this.queue, function (content) {
            saEvent.send(content)
          })
          this.queue = []
        }
      }
    }
  }

  ws.track = function (e, p, c) {
    if (saEvent.check({
        event: e,
        properties: p
      })) {
      saEvent.send({
          type: 'track',
          event: e,
          properties: p
        },
        c
      );
    }
  };

  ws.trackMode = function () {

    ws.readyState.setState(3);

    pageInfo.initPage();

    ws.batchSend.removePageItems()
    if (ws.para.batch_send) {
      addEvent(window, 'onpagehide' in window ? 'pagehide' : 'beforeunload', function () {
        ws.batchSend.clearPendingStatus();
        ws.quick('autoTrackSinglePage', {}, true);
      });
      ws.batchSend.batchInterval();
    }
    ws.store.init();

    getDataFromNative.fromMiniprogram()

    ws.readyState.setState(4);
    ws.initialState.storeIsComplete = true
    ws.initialState.checkIsComplete()
    if (ws._q && isArray(ws._q) && ws._q.length > 0) {
      each(ws._q, function (content) {
        ws[content[0]].apply(ws, Array.prototype.slice.call(content[1]));
      });
    }
  };

  function strip_ws_properties(p) {
    if (!isObject(p)) {
      return p;
    }
    each(p, function (v, k) {
      if (isArray(v)) {
        var temp = [];
        each(v, function (arrv) {
          if (isString(arrv)) {
            temp.push(arrv);
          } else {
            sdLog('您的数据-', k, v, '的数组里的值必须是字符串,已经将其删除');
          }
        });
        p[k] = temp;
      }
      if (!(isString(v) || isNumber(v) || isDate(v) || isBoolean(v) || isArray(v) || isFunction(v) || k === '$option')) {
        sdLog('您的数据-', k, v, '-格式不满足要求，我们已经将其删除');
        delete p[k];
      }
    });
    return p;
  }

  function filterReservedProperties(obj) {
    var reservedFields = ['uuid', 'user_id', 'events_id', 'app_platform', 'app_name', 'events_time', 'ip', 'service_type', 'device_id', 'country', 'province', 'city', 'model', 'os', 'os_version', 'network_type', 'browser', 'browser_version', 'carrier'];
    if (!isObject(obj)) {
      return;
    }
    each(reservedFields, function (key, index) {
      if (!(key in obj)) {
        return;
      }
      if (index < 3) {
        delete obj[key];
        sdLog('您的属性- ' + key + '是保留字段，我们已经将其删除');
      } else {
        sdLog('您的属性- ' + key + '是保留字段，请避免其作为属性名');
      }
    });
  }

  var kit = {};

  kit.buildData = function (p) {
    var data = {
      msgId: '',
      preset_properties: {
        events_time: new Date().getTime(),
        user_id: ws.store.getUserId(),
        uuid: ws.store.getUUID()
      },
      properties: {}
    };
    if (isObject(p) && isString(p.event)) {
      data.preset_properties.events_id = p.event
      delete p.event
    }

    if (isObject(p) && isString(p.user_id)) {
      data.preset_properties.user_id = p.user_id
      delete p.user_id
    }

    if (isObject(p.properties) && !isEmptyObject(p.properties)) {
      extend(data.properties, p.properties);
    }

    data.preset_properties = extend({}, ws.store.getProps(), data.preset_properties, ws.para.preset_properties);

    filterReservedProperties(data.properties);

    return data;
  };

  kit.sendData = function (data) {
    var data_config = data.properties
    data.msgId = UUID()
    ws.log('sendData:', data);
    if (ws.para.debug_mode === true) {
      ws.saEvent.debugPath(data);
    } else {
      ws.sendState.getSendCall(data);
    }
  };

  var checkOption = {
    regChecks: {
      regName: /^((?!^uuid$|^msgId$|^properties$|^preset_properties$|^users$|^events$|^event$|^user_id$)[a-zA-Z_$][a-zA-Z\d_$]{0,99})$/i
    },
    check: function (a, b) {
      if (typeof this[a] === 'string') {
        return this[this[a]](b);
      } else if (isFunction(this[a])) {
        return this[a](b);
      }
    },
    str: function (s) {
      if (isString(s) && s !== '') {
        return true;
      } else {
        sdLog('请检查参数格式,必须是字符串且有值');
        return false;
      }
    },
    checkPropertiesKey: function (obj) {
      var me = this,
        flag = true;
      each(obj, function (content, key) {
        if (!me.regChecks.regName.test(key)) {
          flag = false;
        }
      });
      return flag;
    },
    properties: function (p) {
      strip_ws_properties(p);
      if (p) {
        if (isObject(p)) {
          if (this.checkPropertiesKey(p)) {
            return true;
          } else {
            sdLog('properties 里的自定义属性名需要是合法的变量名，不能以数字开头，且只包含：大小写字母、数字、下划线，自定义属性不能以 $ 开头');
            return true;
          }
        } else {
          sdLog('properties可以没有，但有的话必须是对象');
          return true;
        }
      } else {
        return true;
      }
    },
    event: function (s) {
      if (!isString(s) || !this['regChecks']['regName'].test(s)) {
        sdLog('请检查参数格式，eventName 必须是字符串，且需是合法的变量名，即不能以数字开头，且只包含：大小写字母、数字、下划线和 $,其中以 $ 开头的表明是系统的保留字段，自定义事件名请不要以 $ 开头');
        return true;
      } else {
        return true;
      }
    },
    userId: function (id) {
      if (isString(id) && /^.{1,255}$/.test(id)) {
        return true;
      } else {
        sdLog('uuid必须是不能为空，且小于255位的字符串');
        return false;
      }
    }
  };

  function check(p) {
    var flag = true;
    for (var i in p) {
      if (Object.prototype.hasOwnProperty.call(p, i) && !checkOption.check(i, p[i])) {
        return false;
      }
    }
    return flag;
  }

  var saEvent = {};

  saEvent.check = check;

  saEvent.send = function (p) {
    if (!ws.initialState.isComplete) {
      ws.initialState.queue.push(p)
      return false
    }
    var data = ws.kit.buildData(p);
    ws.kit.sendData(data);
  };

  saEvent.debugPath = function (data) {
    let key = getRandom(16)
    let iv = getRandom(16)
    var trace_id = UUID()
    if (ws.para.is_encrypt) {
      data = `${key}${iv}${CryptoJSF.AesEncrypt(JSON.stringify([data]), key, iv)}`
    } else {
      data = `${CryptoJSF.Base64Encode(JSON.stringify([data]))}`
    }
    var sendData = {
      trace_id,
      send_time: new Date().getTime(),
      sdk_version: sdkversion_placeholder,
      sdk_type: sdk_type,
      ip: null,
      encrypt: ws.para.is_encrypt,
      gzip: ws.para.is_gzip,
      data
    }
    ajax({
      url: ws.para.debug_mode_url,
      type: 'POST',
      cors: true,
      contentType: 'application/json',
      data: JSON.stringify(sendData),
      header: {
        'trace-id': trace_id
      },
      success: function (res) {
        if (res.code != 1) {
          sdLog(res.message)
        } else {
          sdLog('debug发送成功')
        }
      }
    });
  };

  function autoExeQueue() {
    var queue = {
      items: [],
      enqueue: function (val) {
        this.items.push(val);
        this.start();
      },
      dequeue: function () {
        return this.items.shift();
      },
      getCurrentItem: function () {
        return this.items[0];
      },
      isRun: false,
      start: function () {
        if (this.items.length > 0 && !this.isRun) {
          this.isRun = true;
          this.getCurrentItem().start();
        }
      },
      close: function () {
        this.dequeue();
        this.isRun = false;
        this.start();
      }
    };
    return queue;
  }

  var sendState = {};
  sendState.queue = autoExeQueue();

  sendState.getSendCall = function (data) {
    if (ws.readyState.state < 3) {
      ws.log('初始化没有完成');
      return false;
    }

    if (ws.para.batch_send && localStorage.length < 200) {
      ws.batchSend.add(data);
      return false;
    }
  };

  var commonWays = {
    autoTrackIsUsed: false,
    getStayTime: function () {
      return (new Date() - ws._t) / 1000;
    },
    setDefaultAttr: function () {
      pageInfo.register({
        _current_url: location.href,
        _referrer: getReferrer(),
        _referring_host: pageInfo.pageProp.referrer_host
      });
    },
    autoTrackSinglePage: function (para, isLeave = false, callback) {
      var page_entry_time, page_exit_time, url;
      page_entry_time = new Date().getTime()
      if (this.autoTrackIsUsed) {
        url = pageInfo.pageProp.url;
      } else {
        url = pageInfo.pageProp.referrer;
      }
      para = isObject(para) ? para : {};
      function closure(p, l, c) {
        page_exit_time = new Date().getTime()
        ws.track(
          'PageEnd',
          extend({
              page_path: url,
              page_title: document.title,
            },
            p
          ),
          c
        );
        if (!l) {
          ws.track(
            'PageView',
            extend({
                page_path: getURL(),
                page_title: document.title,
                // referrer_page_path: url,
                // page_entry_time,
                // page_exit_time,
                // event_duration: parseInt((page_exit_time - page_entry_time)/1000)
              },
              p
            ),
            c
          );
          page_entry_time = new Date().getTime()
          url = getURL();
        }
      }
      this.autoTrackSinglePage = closure;
    },
    autoTrack: function (para, callback) {
      para = isObject(para) ? para : {};
      ws.track(
        'PageView',
        extend({
            page_path: getURL(),
            page_title: document.title
          },
          para
        ),
        callback
      );

      this.autoTrackIsUsed = true;
    }
  };

  ws.quick = function () {
    var arg = Array.prototype.slice.call(arguments);
    var arg0 = arg[0];
    var arg1 = arg.slice(1);
    if (typeof arg0 === 'string' && commonWays[arg0]) {
      return commonWays[arg0].apply(commonWays, arg1);
    } else if (typeof arg0 === 'function') {
      arg0.apply(ws, arg1);
    } else {
      ws.log('quick方法中没有这个功能' + arg[0]);
    }
  };

  // 与客户端和小程序的数据交互
  var getDataFromNative = {
    isIos: function() {
      return /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    },
    isAndroid: function() {
      return /(Android)/i.test(navigator.userAgent);
    }
  }
  getDataFromNative.getPointDataFromNative = function(data) {
    sdLog('getPointDataFromNative:', data)
    if (getDataFromNative.isAndroid()) {
      data = JSON.parse(data)
    }
    store.set('user_id', data.userid);
    store.set('uuid', data.uuid);
    ws.initialState.nativeIsComplete = true
    ws.initialState.checkIsComplete()
  }
  getDataFromNative.sendToApp = function () {
    try{
      let params = {
        callback: 'getPointDataFromNative',//定义与原生的方法名
      };
      if (this.isIos()&&window.webkit&&window.webkit.messageHandlers&&window.webkit.messageHandlers.ws_sa_nativeInfo) {
        //调用iOS方法，且传值给iOS （iOS 方法名为 ws_sa_nativeInfo）
        window.webkit.messageHandlers.ws_sa_nativeInfo.postMessage(params);
      } else if (this.isAndroid()&&window.ws&&window.ws.ws_sa_nativeInfo) {
        //调用Android方法，且传值给Android （Android方法名为 ws_sa_nativeInfo）
        window.ws.ws_sa_nativeInfo(JSON.stringify(params));
      } else {
        ws.initialState.nativeIsComplete = true
        ws.initialState.checkIsComplete()
      }
    } catch(error) {
      sdLog('sendToApp:', error)
    }
  }
  getDataFromNative.fromMiniprogram = function() {
    let userInfo = null
    try {
      if (getQueryObject().hasOwnProperty('wsSaData') && getQueryObject().wsSaData) {
        userInfo = JSON.parse(decodeURIComponent(getQueryObject().wsSaData))
        store.set('user_id', userInfo.user_id);
        store.set('uuid', userInfo.uuid);
      }
    } catch (e) {
      sdLog('fromMiniprogram error: ', e)
    }
    return userInfo
  }

  ws.initPara = function () {
    extend(wsPara, ws.para_default, ws.para || {});
    ws.para = wsPara
    ws.para.preset_properties = extend({}, ws.para_default.preset_properties, ws.para.preset_properties || {});

    if (typeof ws.para.server_url === 'string') {
      ws.para.server_url = trim(ws.para.server_url);
      if (ws.para.server_url) {
        if (!dev_url_arr.includes(ws.para.server_url)) {
          if (ws.para.server_url.slice(0, 3) === '://') {
            ws.para.server_url = location.protocol.slice(0, -1) + ws.para.server_url;
          } else if (ws.para.server_url.slice(0, 2) === '//') {
            ws.para.server_url = location.protocol + ws.para.server_url;
          } else if (ws.para.server_url.slice(0, 4) !== 'http') {
            ws.para.server_url = '';
          }
        }
      }
    }

    debug.serverUrl();

    if (_localstorage.isSupport() && isSupportCors() && typeof localStorage === 'object') {
      if (ws.para.batch_send === true) {
        ws.para.batch_send = extend({}, batch_send_default);
      } else if (typeof ws.para.batch_send === 'object') {
        ws.para.batch_send = extend({}, batch_send_default, ws.para.batch_send);
      }
    } else {
      ws.para.batch_send = false;
    }
    if (ws.para.noCache === true) {
      ws.para.noCache = '?' + new Date().getTime();
    } else {
      ws.para.noCache = '';
    }

    if (ws.para.callback_timeout > ws.para.datasend_timeout) {
      ws.para.datasend_timeout = ws.para.callback_timeout;
    }
  };

  ws.setPreConfig = function (_ws) {
    ws.para = _ws.para;
    ws._q = _ws._q;
  };

  ws.setInitVar = function () {
    ws._t = ws._t || 1 * new Date();
  };

  var batchSend = new BatchSend();

  ws.batchSend = batchSend;
  ws.store = store;
  ws.sendState = sendState
  ws.saEvent = saEvent;
  ws.kit = kit
  ws.log = sdLog
  ws.getDataFromNative = getDataFromNative

  ws.init = function () {
    if (ws.readyState && ws.readyState.state && ws.readyState.state >= 2) {
      return false;
    }
    ws.setInitVar()
    ws.readyState.setState(2);
    ws.initPara()
    ws.trackMode()
  }

  ;(function (factory) {
    if (typeof exports === 'object' && typeof module === 'object') {
      module.exports = factory();
    } else {
      factory();
    }
  })(function () {
    try {
      if (typeof window['wsDataStorage'] === 'string') {
        ws.setPreConfig(window[wsDataStorage]);
        window[wsDataStorage] = ws;
        window['wsDataStorage'] = ws;
        window.getPointDataFromNative = ws.getDataFromNative.getPointDataFromNative
        ws.getDataFromNative.sendToApp()
        ws.init();
      } else if (typeof window['wsDataStorage'] === 'undefined') {
        window['wsDataStorage'] = ws;
        return sd;
      } else {
        return window['wsDataStorage'];
      }
    } catch (err) {
      if (typeof console === 'object' && console.log) {
        try {
          console.log(err);
        } catch (e) {
          ws.log(e);
        }
      }
    }
  });
}

export default {
  init
}